import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-app',
  template: `
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.styles.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private translate: TranslateService
    ) {
    translate.setDefaultLang('no');
    translate.use('no');
  }

  ngOnInit() {
  }
}
